import { getInstance } from 'StateManager';
import { MEASUREMENT } from 'StateEvents';
import Updater from './Updater';

export default class MeasurementUpdater extends Updater {
  constructor() {
    super();
    this.addRelevant(MEASUREMENT);
  }

  updateState(newState, event) {
    switch(event.name) {
      case MEASUREMENT.SKIP_ENABLED:
        newState.media.canSkip = true;
        break;
      case MEASUREMENT.SURVEY_COMPLETE:
        newState.measurement.survey_complete = newState.measurement.survey_complete + 1;
        break;
      case MEASUREMENT.SURVEY_INVALID:
        newState.measurement.survey_complete = 2;
        break;
      case MEASUREMENT.EVENT_LOGGED:
        if(!this.alreadyRequested(newState.measurement.request_queue, event.args.name)) {
          newState.measurement.request_queue = newState.measurement.request_queue.concat(event.args);
          this.markMeasured(newState, event.args.name);
        }
        break;
      case MEASUREMENT.LOG_PROGRESS:
        newState.measurement.request_queue = newState.measurement.request_queue.map(this.markProgress(event.args.name));
        break;
      case MEASUREMENT.LOG_COMPLETE:
        newState.measurement.request_queue = newState.measurement.request_queue.filter( req => req.name !== event.args.name );
        break;
    }

    return newState;
  }

  alreadyRequested(requestQueue = [], newRequestName) {
    return requestQueue.find( request => request.name === newRequestName );
  }

  markProgress(requestName) {
    return item => item.name === requestName ? Object.assign({}, item, { inprogress: true }) : item;
  }

  markMeasured(state, name, value = true) {
    const event = this.measurementEventMap[name];
    if(event) {
      state.measurement[event] = value;
    }
  }

  get measurementEventMap() {
    const eventMap = {};

    eventMap[MEASUREMENT.PENDING]                 = 'pending';
    eventMap[MEASUREMENT.IMPRESSION]              = 'impression';
    eventMap[MEASUREMENT.VIDEO_START]             = 'p_0';
    eventMap[MEASUREMENT.FIRST_QUARTILE]          = 'p_25';
    eventMap[MEASUREMENT.MIDPOINT]                = 'p_50';
    eventMap[MEASUREMENT.THIRD_QUARTILE]          = 'p_75';
    eventMap[MEASUREMENT.VIDEO_COMPLETE]          = 'p_100';
    eventMap[MEASUREMENT.VIDEO_VIEW]              = 'view';
    eventMap[MEASUREMENT.COMPLETE]                = 'complete';
    eventMap[MEASUREMENT.VIEWABILITY_ACHIEVED]    = 'viewable';
    eventMap[MEASUREMENT.VIEWABILITY_UNSUPPORTED] = 'viewability_unsupported';
    eventMap[MEASUREMENT.SKIPPED]                 = 'skipped';
    eventMap[MEASUREMENT.ERROR]                   = 'error';
    eventMap[MEASUREMENT.PAUSE]                   = 'pause';
    eventMap[MEASUREMENT.RESUME]                  = 'resume';
    eventMap[MEASUREMENT.MUTE]                    = 'mute';
    eventMap[MEASUREMENT.UNMUTE]                  = 'unmute';
    eventMap[MEASUREMENT.FULLSCREEN]              = 'fullscreen';

    return eventMap;
  }
}

getInstance().registerUpdater(new MeasurementUpdater(), 0);


// WEBPACK FOOTER //
// ./src/Services/State/Updaters/MeasurementUpdater.js